/** "Building history 43 %, about 6 min left" — what a Playground site setting up says instead of
    "not storing" (0117): neutral, never a fault. Pure. */
export function buildingWords(sim: { state: 'priming' | 'building'; progress: number; secondsLeft: number }): string {
  if (sim.state === 'priming') return 'Setting up devices';
  const m = Math.max(1, Math.round(sim.secondsLeft / 60));
  const left = m < 60 ? `${m} min` : `${Math.floor(m / 60)} h ${m % 60} min`;
  return `Building history ${Math.floor(sim.progress * 100)} %, about ${left} left`;
}
